export default __webpack_public_path__ + "images/5185483bc43ee7dd7b2ebdd7eef042f4.jpg";